import {getElementByElementOrId} from "../../../helpers/element";
import {PanesComponent, PanesComponentConfig} from "../components/panes_component";
import {SecondaryPanesManager} from "./secondary_panes_manager";
import {PrimaryPaneManager} from "./primary_pane_manager";
import Collection from "../../../lib/collection";
import {MixinStateMachine} from "../../../lib/mixins/stateable";
import stateMachine from "../instances/state_machine";

export class PanesManager {

    static new(nav, props={}) {
        const panesElement = nav.getRootElement().querySelector(PanesComponentConfig.selector);
        if (!panesElement) { return null }
        return new PanesManager(panesElement, nav, props);
    }

    constructor(id_or_element, nav, props={}) {
        const element = getElementByElementOrId(id_or_element);

        MixinStateMachine(this); // Add the state machine management methods to `this`.
        this.setStateMachine(stateMachine); // Set `this.stateMachine`.

        this.nav = nav;

        this.panesComponent = new PanesComponent(element, this);

        this.primaryPaneManager = PrimaryPaneManager.new(element, this);
        this.secondaryPanesManager = SecondaryPanesManager.new(element, this);

        this.panesCollection = this.getPanesCollection();

        this.defaultPane = this.primaryPaneManager.primaryPane; // The pane we fall back to when panes are closed.
    }

    getPanesCollection() {
        const primaryPanes = this.primaryPaneManager.getPanesCollection();
        const secondaryPanes = this.secondaryPanesManager.getPanesCollection();
        return new Collection().concat(primaryPanes, secondaryPanes);
    }

    findPaneByIdentifier(identifier) {
        if (!this.panesCollection || typeof this.panesCollection.findByProp !== 'function') { return null }
        return this.panesCollection.findByProp('identifier', identifier);
    }

    /**
     * Find a Pane from the panes collection that matches the current pane identifier from the app's global state.
     * If we can't find a pane matching the currentPaneId then we get the default pane.
     *
     * @returns {Pane} The current pane from the global app state.
     */
    getCurrentPane() {
        const paneId = this.readStateMachineValue('currentPaneId');
        const pane = this.findPaneByIdentifier(paneId);
        return pane ? pane : this.defaultPane;
    }

    openPane(pane) {
        this.dispatchAction('openPane', pane);
    }

    openDefaultPane() {
        this.openPane(this.defaultPane)
    }

    closeSecondaryPanes() {
        this.openDefaultPane();
    }

    isFocusingPrimaryPane() {
        const pane = this.getCurrentPane();
        if (!pane) { return false }
        return pane.isPrimaryPane();
    }

    isFocusingSecondaryPane() {
        const pane = this.getCurrentPane();
        if (!pane) { return false }
        return pane.isSecondaryPane();
    }

    readInternalStateValue(stateKey) {
        return this.internalState()[stateKey];
    }

    internalState() {
        return {
            focusingPrimaryPane: this.isFocusingPrimaryPane(),
            focusingSecondaryPane: this.isFocusingSecondaryPane(),
        }
    }

}
